module.exports = __webpack_public_path__ + "static/bottom-center-08b1f3f2ae2dae072f6b89c143acceca.png";